/**
 * @file: 删除操作还原
 * @author: xiaolong.huang@dmall.com
 */

import * as CubeTree from '../../../cubeTree/index';
import Remove from '../../remove/index';
import Select from '../../select/index';
import Visit from '../../visit';
import { updateCubeList } from '../../../update/updateCubeList';
import { updateEnd } from '../../../update/updateEnd';
import { updateAllShelfsClass } from '../../../update/updateAllShelfsClass';

// 撤销
async function removeStackOut(stackOutItem: StackOutItem|null): Promise<void> {
    let historyItems: RemoveHistoryItem[] = stackOutItem.data;
    let addCubes: CubeId[] = await runHistoryItems(historyItems);
    let updateList: CubeId[] = makeUpdateList(addCubes);

    updateCubeList(updateList);
    Select.clear();
    Select.addGroup(addCubes);
    Select.panelSelectAsync();
    updateAllShelfsClass();
    updateEnd();
}

async function runHistoryItems(historyItems: RemoveHistoryItem[]): Promise<CubeId[]> {
    let addCubes: CubeId[] = [];

    for (let i = 0; i < historyItems.length; i++) {
        let task: InsertInfo = makeInsertTask(historyItems[i]);
        let cubes: CubeId[] = await Visit.Add.runNormalInsert([task]);

        addCubes = addCubes.concat(cubes);
    }

    return addCubes;
}

function makeInsertTask(historyItem: RemoveHistoryItem): InsertInfo {
    let insertIndex: number = 0;
    let parent: CubeId = historyItem.parent;

    if (historyItem.before) {
        parent = CubeTree.findParentIdByCubeId(historyItem.before);
        insertIndex = CubeTree.getCubeIndexInParent(historyItem.before);
    }
    else {
        insertIndex = CubeTree.findChildCubeIds(parent).length;
    }

    return {
        insertData: historyItem.cubeData,
        parentId: parent,
        index: insertIndex
    };
}

function makeUpdateList(cubeIds: CubeId[]): CubeId[] {
    let result: Set<CubeId> = new Set();

    cubeIds.forEach((cubeId: CubeId): void => {
        let parent: CubeId = CubeTree.findParentIdByCubeId(cubeId);

        if (CubeTree.isSketchpad(parent)) {
            return;
        }

        result.add(parent);
    });

    return Array.from(result);
}

export {
    removeStackOut
};
